import React from "react";
import { motion } from "framer-motion";
import CategoryModal from "../../components/CategoryModal";
import Banner from "../../components/Dashboard/Banner";
import DailyGrounding from "../../components/Dashboard/DailyGrounding";
import DashboardSkeleton from "../../components/Dashboard/DashboardSkeleton";
import { useAuth } from "../../context/AuthContext";

const containerVariants = {
    hidden: {}, // Let the global fade handle opacity
    visible: {
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.1,
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 15 }, // More subtle float
    visible: { 
        opacity: 1, 
        y: 0,
        transition: {
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1], // Custom Zen Cubic Bezier
        }
    },
};

export default function DashboardCore({ role, children }) {
    const { user, loading } = useAuth();

    if (loading) {
        return <DashboardSkeleton />;
    }

    // 🧘 Guest Support: Allow dashboard to render even if no user is present
    // Children will handle their own Guest UI logic

    return (
        <>
            {user && <CategoryModal user={user} onComplete={() => window.location.reload()} />}
            <div className="min-h-[calc(100vh-60px)] px-4 pt-6 pb-10 bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 transition-colors duration-300">
                <motion.div
                    className="max-w-7xl mx-auto"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {/* Header & Banner */}
                    <motion.div variants={itemVariants} className="mb-6">
                        <DailyGrounding />
                        <Banner role={role} user={user} />
                    </motion.div>

                    {/* Role Specific Content */}
                    {children}

                </motion.div>
            </div>
        </>
    );
}
